"use strict";

angular.module("customer")
.component("returnedQuantity", {
    bindings: {
        quantity: "=",
        catalogEntry: "=",
        catalogEntryVariant: "=?",
        shouldShowSuggestedOrderMultiplier: "<?",
        forceInputText: "<?",
        ignoreAutoSave: "<?",
        vendor: "<",
        useVariableMeasure: "<?",
        isInventoryReturn: "<?"
    },
    templateUrl: require("./quantity.component.html"),
    controller: function($scope, StocksService, CartItemService, ModalService, common, IS_MOBILE, IS_MOBILE_APP) {
        var _this = this;
        var initialQuantity = this.quantity || 0;
        $scope.isTouchOptimized = !this.forceInputText && (IS_MOBILE || IS_MOBILE_APP);

        this.getLengthClass = function() {
            return StocksService.getLengthClass(this.quantity);
        };

        this.isOrderedButtonDisabled = function() {
            return false;
        };

        this.isQuantityChanged = function() {
            return initialQuantity !== this.quantity;
        };

        this.getErrorClass = function() {
            var isOrderedWithQuantityOfMeasureValid = CartItemService.isOrderedWithQuantityOfMeasureValid(this.catalogEntry, this.vendor);

            return {
                'quantity-error': !isOrderedWithQuantityOfMeasureValid,
                'value-changed': this.isQuantityChanged(),
                'value-unchanged': !this.isQuantityChanged(),
                'disabled': this.isOrderedButtonDisabled()
            }
        };

        this.changeQuantity = function($event) {
            $event.stopPropagation();
            var catalogEntry = this.catalogEntry;
            var currentQuantity = this.quantity;

            ModalService.showModal({
                templateUrl: require("./modals/returned-quantity.modal.html"),
                controller: "ReturnedQuantityModalController",
                controllerAs: "returnedQuantityCtrl",
                inputs: {
                    $attrs: {
                        originalQuantity: currentQuantity,
                        suggestedOrderMultiplier: catalogEntry.suggested_order_multiplier,
                        packagingQuantity: catalogEntry.packaging_quantity,
                        availableQuantities: catalogEntry.minimal_available_quantities,
                        vendor: _this.vendor
                    }
                }
            }).then(function(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
                modal.close.then(function(quantity) {
                    modal.element.remove();
                    if (quantity >= 0 && quantity !== currentQuantity) {
                        _this.saveQuantity(quantity);
                    }
                });
            });
        };

        this.saveQuantity = function(quantity) {
            if (this.ignoreAutoSave) {
                return;
            }

            var promise;
            if (this.isInventoryReturn) {
                promise = CartItemService.saveInventoryReturnQuantity(
                    this.catalogEntry, this.catalogEntryVariant, quantity, this.vendor
                );
            } else {
                promise = CartItemService.saveReturnQuantity(
                    this.catalogEntry, this.catalogEntryVariant, quantity, this.vendor
                );
            }

            promise.then(function onSuccess() {
                _this.quantity = quantity;
            });
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/ordered-quantity/returned-quantity.component.js
// module id = 805
// module chunks = 0